import { accountObj, agencyObj } from '@akerolabs/akero-vue/src/store'
import { request } from '@akerolabs/akero-vue/src/utils/request'

/**
 * @param {Object} current
 * @param {Object} campaigns
 * @return {Array}
 * @memberof campaignSidebarHelpers
 * @public
 * @description A simple method for returning a new array containing only
 * the folders.
 */
export function mapFolders(current, campaigns) {
  const folders = campaigns.filter((campaign) => {
    if (campaign.isFolder) {
      if (!current) return true
      if (current && campaign._id !== current._id) {
        if (campaign.parent === current._id) return false
        return true
      }
    }

    return false
  })

  folders.forEach(function (folder) {
    const result = getPathDepth(folder, campaigns, true)
    folder.path = result.path
    folder.depth = result.depth
    folder.children = result.children
  })

  return folders
}

/**
 * @param {Object} current
 * @param {Array} campaigns
 * @return {Object}
 * @description Returns the depth and path for the current folder
 */
export function getPathDepth(current, campaigns) {
  let path = []
  let depth = 0

  if (current.parent) {
    depth += 1

    const parent = campaigns.find((i) => i._id === current.parent)
    const result = getPathDepth(parent, campaigns, false)
    path = path.concat(result.path)
    depth += result.depth
  }

  return {
    path: path.reverse(),
    depth: depth,
  }
}

/**
 * @param {Object} campaign
 * @return {Number}
 * @description Returns the depth of nested child folders in the given
 * folder.
 */
export function getChildDepth(folder) {
  let result = 0
  let highestChildResult = 0
  let folders = []

  if (Array.isArray(folder.children) && folder.children.length > 0) {
    folders = folder.children.filter((child) => {
      return child.isFolder
    })
  }

  if (folders.length > 0) {
    result += 1
    folder.children.forEach((child) => {
      if (!child.isFolder) return
      const childResult = getChildDepth(child)
      if (childResult > highestChildResult) {
        highestChildResult = childResult
      }
    })
  }

  return result + highestChildResult
}

/**
 * @return {Boolean}
 * @description Checks that a netsuite campaign name has not been used
 * on this account...
 */
export async function checkNetsuiteCampaignName(campaign) {
  if (!campaign.campaignName) {
    return false
  }

  const req = {
    params: {
      account: accountObj()._id,
      agency: agencyObj()._id,
      campaignName: campaign.campaignName,
      deleted: JSON.stringify({ $ne: true }),
    },
  }

  if (campaign.id) {
    req.params._id = JSON.stringify({ $ne: campaign.id })
  }

  const { data: res } = await request.get('/campaigns', req)

  if (res.data && res.data.length) {
    return true
  }

  return false
}
